import { mathUtils } from '@festina-life/core'

export const ARROW_LINE_HORIZONTAL_PADDING = 15
export const ARROW_HEAD_HEIGHT = 20
export const ARROW_LINE_WIDTH = 8
export const DOT_RADIUS = 8
export const INHERITED_DOT_RADIUS = 6
export const ACTIVE_DOT_STROKE = 1
export const INACTIVE_DOT_STROKE = 0.3
export const DATE_HEADING_HEIGHT = 20
export const DATE_FOOTER_HEIGHT = 20

// Calculated Values
const ARROW_HEAD_SIDE_LENGTH =
  ARROW_HEAD_HEIGHT / Math.sin(mathUtils.degreesToRadians(60))
export const ARROW_HEAD_BIG_RADIUS =
  ARROW_HEAD_SIDE_LENGTH / 2 / Math.cos(mathUtils.degreesToRadians(30))
export const ARROW_HEAD_SMALL_RADIUS =
  ARROW_HEAD_BIG_RADIUS * Math.sin(mathUtils.degreesToRadians(30))
